module.exports = __webpack_public_path__ + "static/media/bg-waves.06a0cbca.png";